<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9999 2C17.5224 2 22 6.47757 22 11.9999C22 17.5224 17.5224 22 11.9999 22C6.47757 22 2 17.5224 2 11.9999C2 6.47757 6.47757 2 11.9999 2Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.706 8.72736L9.99962 17.4342L5.29297 12.7273L6.70685 11.3134L9.99962 14.6061L17.292 7.31348L18.706 8.72736Z"
      fill="white"
    />
  </svg>
</template>
